module.exports = __webpack_public_path__ + "media/pricing/Truck_Supply_Checklist-0c6020e6.pdf";